<template>

    <ion-row>

      <ion-col>
        <h2>
          Summary
        </h2>

        As a polyglot developer, Edward Turner has experience creating innovative
        solutions using Python, R and Scala. Edward utilizes the Apache-Spark
        framework within his technical stack in his current data-driven
        software development projects, while utilizing best practices for
        software development using python. Edward also has experience building
        web applications using micro-frameworks in python (i.e. Flask, FastAPI),
        and using dockerized solutions to deploy machine learning and
        deep learning models (i.e. tensorflow/serving, fastapi) into production.
      </ion-col>
    </ion-row>

</template>

<script>
import { IonRow, IonCol } from '@ionic/vue';


export default {
  name: 'About',
  components: {
    IonRow, IonCol
  }
}
</script>
